import { PropsWithChildren } from 'react';
import { Edit } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';

interface Props {
  onClick: () => void;
  disabled?: boolean;
  isMobile?: boolean;
}
export const LabelEdit = ({ children, onClick, disabled, isMobile = false }: PropsWithChildren<Props>) => (
  <Box
    display="flex"
    alignItems="center"
    gap={1}
    height={isMobile ? 'auto' : 20}
    sx={{
      cursor: 'pointer', minHeight: isMobile ? 44 : undefined, minWidth: 0,
    }}
  >
    <Box
      sx={{
        maxWidth: isMobile ? '100%' : 200, minWidth: 0,
        '.MuiTypography-root': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: isMobile ? 'normal' : 'nowrap', overflowWrap: isMobile ? 'anywhere' : undefined,
        },
      }}
    >
      {children}
    </Box>
    {(Boolean(isMobile && disabled) == false) && (
      <IconButton disabled={disabled} onClick={onClick} size="small">
        <Edit fontSize="small" />
      </IconButton>
    )}
  </Box>
);
